<template>
    <section class="font-poppins">
        <div class="flex justify-between">
            <div class="w-2/3 md:w-full p-2">
                <div class="flex justify-between mt-8">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">3/4</p>
                </div>

                <div class="flex justify-center">
                    <div>
                        <div class="text-4xl mt-10 flex justify-content-center">
                            <h2 class="text-blue-600 font-semibold md:text-lg" style="color:rgb(18,84,179)">Sign Up for HP Scheme</h2>
                        </div>
                        <div class="w-4/5 md:w-full">
                            <div class="mt-8 font-semibold">
                                <p>Personal Information</p>
                            </div>
                            <div class="mt-5">
                                <form @submit.prevent="submitDetails">
                                    <div>
                                        <input class="p-2 pl-2 w-full rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179) " type="text" name="firstName" id="firstName" placeholder="First Name" v-model="firstName"> <br>
                                        <p v-show="firstNameValidity" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    <div>
                                        <input class="mt-4 w-full p-2 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" type="text" name="lastName" id="LastName" placeholder="Last Name" v-model="lastName"><br>
                                        <p v-if="lastNameValidity" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                
                                    <div>
                                        <input class="mt-4 w-full p-1 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" :type="[showPassword ? 'text' : 'password']"  name="password" id="password" placeholder="Password" v-model="password">
                                        <span @click="showPassword = !showPassword">
                                            <i class="fa  -ml-8 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                        </span>
                                        <p v-if="passwordValidity" class=" text-xs text-red-500">Password must contain at least one number and greater than 8 characters</p>
                                        
                                    </div>
                                    <div>
                                        <input class="mt-4 w-full p-1 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" :type="[showPassword2 ? 'text' : 'password']"  name="confirm-password" id="confirm-password" placeholder="Confirm Password" v-model="confirmPassword">
                                        <span @click="showPassword2 = !showPassword2">
                                            <i class="fa  -ml-8 mt-4" :class="[showPassword2 ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                        </span>
                                        <p v-if="confirmPasswordValidity" class=" text-xs text-red-500">Password did not match</p>
                                        
                                    </div>
                            
                                    <div class="mt-4">
                                        <p>Date of Birth</p>
                                        <input class="mt-2 w-full p-1 pl-2 rounded-lg text-sm" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)" type="date" name="dob" id="dob" placeholder="Date of Birth" v-model="dob">
                                        <p v-if="dobValidity" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    
                                    <div class="mt-2">
                                        <p>Gender</p>
                                        <select class="mt-2 w-full p-1 rounded-lg" style="background-color:whitesmoke; border:1px solid rgb(18,84,179)"  name="gender" id="gender" v-model="gender">
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                        <p v-if="genderValidity" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>
                                    
                                    <div class=" mt-2">
                                        <p>Country</p>
                                        <select style="background-color:whitesmoke; border:1px solid rgb(18,84,179)"  class="w-full p-1 rounded-lg border pl-2 mt-1" name="countries" id="countries" v-model="country" @change="selectedCountry($event)">
                                            <option v-for="allCountry in countries" :key="allCountry" :value="allCountry">{{allCountry}}</option>
                                        </select>
                                        <p v-if="countryValidity" class=" text-xs text-red-500">This field cannot be empty</p>
                                    </div>

                                    <div class="mt-2">  
                                        <p>State</p>                                                 
                                        <select style="background-color:whitesmoke; border:1px solid rgb(18,84,179)"  class=" w-full p-1 rounded-lg border pl-2 mt-1"  name="state" id="state"  v-model="state" @change="selectedState($event)">
                                            <option v-for="allStates in states" :key="allStates" :value="allStates">{{allStates}}</option>
                                        </select> 
                                        <p v-if="stateValidity" class=" text-xs text-red-500">This field cannot be empty</p>                                      
                                    </div>
                                    <div>
                                        <p class="text-sm text-red-500">{{error}}</p>
                                    </div>
                                    <div>
                                        <div class="flex mt-5 text-sm">
                                            <input  type="checkbox" class="mt-2 mr-4" name="t&c" id="t&c" v-model="checkbox">
                                            <p>By creating an account, you are agreeing to our
                                                <a @click="showPolicy" class="text-blue-500 cursor-pointer" >Terms of service</a> and <a @click="showPolicy" class="text-blue-500 cursor-pointer">Privacy policy</a>
                                            </p>
                                            
                                        </div>
                                        <p v-if="checkValidity" class=" text-xs text-red-500">Accept T&C to proceed</p>
                                    </div>
                                    

                                    <div class="mt-10 flex">
                                        <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Proceed</button>
                                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                    </div>
                                </form>                              
                            </div>
                        </div>                        
                    </div>                   
                </div>               
            </div>
            <div class="image w-1/3 md:hidden ">

            </div>
        </div>

        <div class="lg:hidden mt-16">
            <the-footer/>
        </div>

        <div>
            <TermsPolicyModal
            v-show="termsPolicy"
            @close="closeModal"
            />
        </div>
    </section>
</template>

<script>
import TermsPolicyModal from '../TermsPolicyModal.vue';
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    components:{TermsPolicyModal},

    data() {
        return {
            countryCode: [],
            countries: [],
            states: [],
            firstName: "",
            lastName: "",
            password: "",
            phoneNumber: this.$store.state.userPhone,
            dob: "",
            gender: "",
            country: "",
            state: "",
            checkbox: "",
            confirmPassword : "",

            firstNameValidity: false,
            lastNameValidity: false,
            passwordValidity: false,
            dobValidity: false,
            genderValidity: false,
            countryValidity: false,
            stateValidity: false,
            checkValidity: false,
            isLoading: false,
            isEmailTaken: "",
            showPassword:false,
            showPassword2: false,
            confirmPasswordValidity: "",
            error : "",
            termsPolicy: ""

        }
    },

    mounted() {
        this.get_countries();
        this.networkError();
    },

    methods: {
         showPolicy() {
            this.termsPolicy = true;
        },
         closeModal() {
            this.termsPolicy = false;
        },

        selectedCountry(event){
            const selectedCountry = event.target.value;
            this.states = this.theCountries[selectedCountry]            
        },

        selectedState(event) {
            event.target.value
        },

        get_countries() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/extras/countries`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
             .then((response) => {
                 this.countries =  Object.keys(response.data.data)
                 this.theCountries = response.data.data
             })
             .catch ((error) => {
                 console.log(error)
             })       
        },

        onPhoneNumber(event) {
            this.phoneNumber = event.target.value
        },

        submitDetails() {
            this.networkError();
            if(!this.firstName) {
                this.firstNameValidity = true;
                setTimeout(() => {
                        this.firstNameValidity = false;
                    }, 4000);
            } else if (!this.lastName) {
                this.lastNameValidity = true;
                setTimeout(() => {
                        this.lastNameValidity = false;
                    }, 4000);
            }else if(!this.password || this.password.length < 8 || this.password.search(/[0-9]/) < 0) {
                this.passwordValidity = true;
                setTimeout(() => {
                        this.passwordValidity = false;
                    }, 4000);
            } else if(this.confirmPassword !== this.password){
                this.confirmPasswordValidity = true;
                setTimeout(() => {
                        this.confirmPasswordValidity = false;
                    }, 4000);
            }else if (!this.gender) {
                this.genderValidity = true;
                setTimeout(() => {
                        this.genderValidity = false;
                    }, 4000);
            } else if (!this.dob) {
                this.dobValidity = true;
                setTimeout(() => {
                        this.dobValidity = false;
                    }, 4000);
            } else if(!this.country) {
                this.countryValidity = true;
                setTimeout(() => {
                        this.countryValidity = false;
                    }, 4000);
            } else if (!this.state) {
                this.stateValidity = true;
                setTimeout(() => {
                        this.stateValidity = false;
                    }, 4000);
            } else if(!this.checkbox) {
                this.checkValidity = true;
                setTimeout(() => {
                        this.checkValidity = false;
                    }, 4000);
            } 
            else {
                this.isLoading = true;
                axios({
                method: "POST",
                url: `${url}/v1/web/riders/create`,
                headers: {
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    firstName: String(this.firstName),
                    lastName: String(this.lastName),
                    email: String(localStorage.getItem("hpEmail")),
                    password: String(this.password),
                    phone: String(localStorage.getItem("hpPhone")),
                    dob: String(this.dob),
                    gender: String(this.gender),
                    country: String(this.country),
                    state: String(this.state),
                }
                })
                .then((res) => {
                    this.$store.commit("setAuthentication", true)            
                    res;
                    this.isLoading = false;
                    this.$router.push("/step3-registration")
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                    setTimeout(() => {
                        this.error = false;
                    }, 4000);
                    this.isLoading = false;
                })
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
